import { render, staticRenderFns } from "./subEdit.vue?vue&type=template&id=0dd24ffd&scoped=true&"
import script from "./subEdit.vue?vue&type=script&lang=js&"
export * from "./subEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd24ffd",
  null
  
)

export default component.exports